export var getAddressType = function getAddressType(address) {
  console.log('address', address);

  if (address.isBillingAddress) {
    return 'billing';
  }

  if (address.isDeliveryAddress) {
    return 'delivery';
  }

  if (address.isShippingAddress) {
    return 'shipping';
  }

  return 'shipping';
};